// eslint-disable-next-line import/prefer-default-export
export const STATUS_USER_INFO = {
  NOT_FOUND: 'not_found',
  REVIEWING: 'reviewing',
  APPROVED: 'approved',
  REJECTED: 'rejected',
}
